import React from "react";
import PropTypes from "prop-types";
import uuidv4 from "uuid";

//material ui:
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { Tooltip, Fade } from "@material-ui/core";

//components:
import FloatNumberFormatInput from "../../components/float_number_input_formatter";
import DatePicker from "../../components/utils/DatePicker";

const drawerWidth = 240;

const styles = theme => ({
  root: {
    height: "100%",
    width: drawerWidth
  },
  pairContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minWidth: 520
  },
  formControl: {
    display: "flex",
    justifyContent: "center",
    margin: "5px 25px",
    minWidth: 120,
    height: 72,
    width: 185
  },
  buttonsContainer: {
    marginLeft: 16
  },
  button: {
    margin: "15px 15px 15px 0",
    padding: "10px 4%",
    borderRadius: 0,
    textTransform: "capitalize",
    color: "white",
    border: "none",
    boxShadow: "none"
  },
  inputImporte: {
    textAlign: "right"
  },
  tooltip: {
    fontSize: 14,
    color: "white",
    backgroundColor: "#3a3434",
    fontWeight: 200
  }
});

class EditMktGrid extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: this.props.factura.id ? this.props.factura.id : uuidv4(),
      fechaFra: this.props.factura.fechaFra
        ? this.props.factura.fechaFra.slice(0, 10)
        : this.props.fecha,
      factura: this.props.factura.factura ? this.props.factura.factura : "",
      cliente: this.props.factura.cliente ? this.props.factura.cliente : "",
      importe: this.props.factura.importe ? this.props.factura.importe : 0.0,
      cobrada: this.props.factura.cobrada ? this.props.factura.cobrada : false,
      tipoZona: this.props.factura.tipoZona
        ? this.props.factura.tipoZona
        : this.props.zonas[0].descr,
      articuloId: this.props.factura.articuloId
        ? this.props.factura.articuloId
        : this.props.zonas[0].id,
      artMKTLocked: this.props.producto ? true : false
    };
  }

  handleChange = event => {
    this.setState({ cobrada: event.target.checked });
  };

  handleValueChange = (event, field) => {
    this.setState({ ...this.state, [field]: event.target.value });
  };

  handleZonaChange = event => {
    this.setState({
      ...this.state,
      articuloId: event.target.value,
      tipoZona: this.props.zonas.find(
        tz => tz.id === parseInt(event.target.value)
      ).descr
    });
  };

  handleDateValueChange = event => {
    this.setState({ ...this.state, fechaFra: event });
  };

  compare = (a, b) => {
    if (a.descr < b.descr) return -1;
    if (a.descr > b.descr) return 1;
    return 0;
  };

  fillZonas = () => {
    return [...this.props.zonas].sort(this.compare).map((zona, index) => {
      return (
        <option key={zona.id} value={zona.id}>
          {zona.descr}
        </option>
      );
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <form className={classes.root} autoComplete="off">
        <div>
          <Tooltip
            title={"Zona en que se imputa el cobro"}
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 500 }}
            placement="top"
            classes={{ tooltip: this.props.classes.tooltip }}
          >
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="zona-placeholder">Zona</InputLabel>

              <Select
                native
                value={this.state.articuloId}
                onChange={event => this.handleZonaChange(event)}
                name="zonaId"
                inputProps={{ readOnly: this.state.artMKTLocked }}
              >
                {this.fillZonas()}
              </Select>
            </FormControl>
          </Tooltip>

          <div className={classes.pairContainer}>
            <Tooltip
              title={"Fecha de la factura del cliente"}
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 500 }}
              placement="top"
              classes={{ tooltip: this.props.classes.tooltip }}
            >
              <FormControl className={classes.formControl}>
                {/* <TextField
                                    id={'fechaFra'}
                                    label={'Fecha Factura'}
                                    type="date2"
                                    value={this.state.fechaFra}
                                    className={classes.input}
                                    onChange={(event) => this.handleDateValueChange(event)}
                                    disabled
                                /> */}
                <DatePicker
                  label={"Fecha Factura"}
                  value={this.state.fechaFra}
                  className={classes.input}
                  onChange={event => {
                    if (event && !isNaN(event)) {
                      const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                      this.handleDateValueChange(d.toISOString());
                    }
                  }}
                />
              </FormControl>
            </Tooltip>

            <Tooltip
              title={"Número de la factura del cliente"}
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 500 }}
              placement="top"
              classes={{ tooltip: this.props.classes.tooltip }}
            >
              <FormControl className={classes.formControl}>
                <TextField
                  id={"factura"}
                  label={"# Factura"}
                  placeholder={"Factura"}
                  value={this.state.factura}
                  onChange={event => this.handleValueChange(event, "factura")}
                />
              </FormControl>
            </Tooltip>
          </div>

          <div className={classes.pairContainer}>
            <FormControl className={classes.formControl}>
              <TextField
                id={"cliente"}
                label={"Cliente"}
                placeholder={"Cliente"}
                value={this.state.cliente}
                onChange={event => this.handleValueChange(event, "cliente")}
              />
            </FormControl>

            <FormControl className={classes.formControl}>
              <TextField
                id={"importe"}
                label={"Importe"}
                placeholder={"Importe"}
                className={classes.input}
                InputProps={{
                  classes: { input: classes.inputImporte },
                  inputComponent: FloatNumberFormatInput
                }}
                value={this.state.importe}
                onChange={event => this.handleValueChange(event, "importe")}
              />
            </FormControl>
          </div>

          <Tooltip
            title={"Indica si ha sido cobrada en el centro"}
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 500 }}
            placement="top"
            classes={{ tooltip: this.props.classes.tooltip }}
          >
            <FormControl className={classes.formControl}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.cobrada}
                    onChange={this.handleChange}
                    value="cobrada"
                    color="primary"
                  />
                }
                label="¿Cobrada?"
              />
            </FormControl>
          </Tooltip>
        </div>

        <div className={classes.buttonsContainer}>
          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={() => this.props.hideDialog()}
          >
            Cerrar
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => {
              const factura = {
                id: this.state.id,
                fechaFra: this.state.fechaFra,
                factura: this.state.factura,
                cliente: this.state.cliente,
                importe: this.state.importe,
                cobrada: this.state.cobrada,
                fecha: this.props.fecha,
                usuarioId: this.props.usuario,
                articuloId: this.state.articuloId,
                tipoZona: this.state.tipoZona
              };

              if (this.props.checkValues(factura)) {
                this.props.okHandler(factura);
                this.props.hideDialog();
              }
            }}
          >
            Guardar
          </Button>
        </div>
      </form>
    );
  }
}

EditMktGrid.propTypes = {
  factura: PropTypes.object,
  producto: PropTypes.object.isRequired,
  zonas: PropTypes.object.isRequired,
  okHandler: PropTypes.func.isRequired,
  checkValues: PropTypes.func.isRequired,
  usuario: PropTypes.number.isRequired,
  fecha: PropTypes.string.isRequired,
  hideDialog: PropTypes.func.isRequired
};

export default withStyles(styles, { withTheme: true })(EditMktGrid);
